import Api from './api'
const validateDomain = (data) => Api().post('auth/verifyEmail', data)

export default {
    validateDomain
}
